import { NS } from "../common/classes";

export const FLOATING_INPUT = `${NS}-floating-input`;
export const FLOATING_INPUT_CONTAINER = `${FLOATING_INPUT}-container`;
export const FLOATING_INPUT_LABEL = `${FLOATING_INPUT}-label`;
export const FLOATING_INPUT_INVISIBLE = `${FLOATING_INPUT}-invisible`;
export const FLOATING_INPUT_FIXED_PLACEHOLDER = `${FLOATING_INPUT}-fixed-placeholder`;
export const FLOATING_INPUT_COUNTER = `${FLOATING_INPUT}-counter`;
